const onEsc =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'Escape') {
      handler(e, ...args);
    }
  };

export default onEsc;
